if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.pillsWrapper = this.querySelector('[data-card-variant-pills]');
        if (!this.pillsWrapper) return;

        this.priceEl = this.querySelector('[data-card-price]');
        this.compareEl = this.querySelector('[data-card-compare-price]');
        this.badgeEl = this.querySelector('[data-card-badge]');
        this.activeVariantEl = this.querySelector('[data-card-active-variant]');
        this.variantIdInput = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[data-card-submit]');
        this.submitButtonText = this.submitButton
          ? this.submitButton.querySelector('[data-card-submit-label]')
          : null;

        this.pillsWrapper.addEventListener('click', this.onPillClick.bind(this));
      }

      onPillClick(event) {
        const pill = event.target.closest('[data-variant-id]');
        if (!pill || pill.getAttribute('aria-disabled') === 'true') return;

        this.pillsWrapper.querySelectorAll('[data-variant-id]').forEach((el) => {
          el.classList.remove('is-active');
          el.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');

        this.updateVariant(pill.dataset);
      }

      updateVariant(data) {
        if (this.priceEl && data.priceFormatted) this.priceEl.textContent = data.priceFormatted;

        if (this.compareEl) {
          if (data.compareAtPriceFormatted) {
            this.compareEl.textContent = data.compareAtPriceFormatted;
            this.compareEl.hidden = false;
          } else {
            this.compareEl.hidden = true;
          }
        }

        if (this.badgeEl) {
          if (data.badgeText) {
            this.badgeEl.textContent = data.badgeText;
            this.badgeEl.hidden = false;
          } else {
            this.badgeEl.hidden = true;
          }
        }

        if (this.activeVariantEl && data.title) {
          this.activeVariantEl.textContent = `· ${data.title}`;
        }

        if (this.variantIdInput) this.variantIdInput.value = data.variantId;

        const available = data.available === 'true';
        if (this.submitButton) {
          this.submitButton.toggleAttribute('disabled', !available);
          this.submitButton.setAttribute('aria-disabled', (!available).toString());
          const actionLabel = available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
          this.submitButton.setAttribute('aria-label', `${actionLabel} — ${this.dataset.productTitle}`);
        }
        if (this.submitButtonText) {
          this.submitButtonText.textContent = available
            ? window.variantStrings.addToCart
            : window.variantStrings.soldOut;
        }
      }
    }
  );
}
